import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { Printer, X } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import InvoiceSheet from "@/components/InvoiceSheet";
import { api, errMsg } from "@/lib/api";

export default function InvoiceDoc() {
  const { id } = useParams();
  const [sp] = useSearchParams();
  const [d, setD] = useState(null);
  const [acc, setAcc] = useState({});
  const [co, setCo] = useState({});
  const [err, setErr] = useState("");

  useEffect(() => {
    api.get(`/invoices/${id}`).then((r) => {
      setD(r.data);
      api.get(`/accounts/${r.data.account_id}`).then((a) => setAcc(a.data)).catch(() => {});
    }).catch((e) => setErr(errMsg(e)));
    api.get("/company").then((r) => setCo(r.data)).catch(() => {});
  }, [id]);

  useEffect(() => {
    if (!d || sp.get("print") !== "1") return undefined;
    const t = setTimeout(() => window.print(), 600);
    return () => clearTimeout(t);
  }, [d, sp]);

  if (err) return <div className="flex h-screen flex-col items-center justify-center gap-2" data-testid="invoice-error"><div className="font-display text-2xl font-bold">Fatura bulunamadı</div><div className="text-sm text-muted-foreground">{err}</div></div>;
  if (!d) return <div className="flex h-screen items-center justify-center label-eyebrow">Yükleniyor…</div>;

  return (
    <div className="min-h-screen bg-teal-900/10 py-8 print:bg-white print:py-0">
      <div className="no-print mx-auto mb-4 flex max-w-[210mm] justify-end gap-2 px-2">
        <Button onClick={() => window.print()} className="rounded-[4px] bg-teal-700 hover:bg-teal-800" data-testid="invoice-print-button"><Printer /> Yazdır</Button>
        <Button variant="outline" onClick={() => window.close()} className="rounded-[4px] bg-white" data-testid="invoice-close-button"><X /> Kapat</Button>
      </div>
      <InvoiceSheet d={d} acc={acc} co={co} />
    </div>
  );
}
